import React, { useState, useEffect } from "react";
import { Row, Col, Modal, Tabs, Card, Descriptions } from "antd";
import moment from "moment";

import api from "../../../services/api";
import { Itens, FormaPagamento } from "./pages";
import { HasValue, isObjetoDiffVazio } from "../../../services/funcoes";
import { FormatFone, MaskFormat } from "../../../ValueObjects";

export default function ModalDetalhesNotaFiscal({ detalhesNF, setDetalhesNF, exibirModalDetalhesNotaFiscal, fecharModalDetalhesNotaFiscal }) {

    const [abaSelecionada, setAbaSelecionada] = useState("1");
    const [arrFinalidade] = useState(["NF-E NORMAL", "NF-E COMPLEMENTAR", "NF-E DE AJUSTE", "DEVOLUÇÃO"]);
    const [arrAmbiente] = useState(["PRODUÇÃO", "HOMOLOGAÇÃO"]);
    const [detalhesNota, setDetalhesNota] = useState({});
    const [modalidadesFrete, setModalidadesFrete] = useState([]);
    const [indPresenca, setIndPresenca] = useState([]);
    const [status, setStatus] = useState([]);

    const onCloseModal = () => {
        setDetalhesNota({});
        setDetalhesNF({});
        fecharModalDetalhesNotaFiscal();
    };

    useEffect(() => {
        if (isObjetoDiffVazio(detalhesNF)) {
            carregarDadosDestinatario(detalhesNF);
            buscarEnuns();
        }
    }, [detalhesNF])

    async function carregarDadosDestinatario(dados) {
        let dadosTemp = { ...detalhesNF };
        let vendedor = [];
        if (!!dadosTemp.ven_id) {
            vendedor = await api.get(`Vendedor/RetornaVendedor?idVendedor=${dadosTemp.ven_id}`);
            dadosTemp.nomeVendedor = vendedor.data.pes_nome;
        }
        setDetalhesNota(dadosTemp);
    }

    function buscarEnuns() {
        api.get(`Enum/Listar?nome=ModalidadeFrete`).then(
            res => {
                setModalidadesFrete(res.data);
            }
        ).catch(
            erro => {
                console.log(erro);
            }
        )

        api.get(`Enum/Listar?nome=IndicadorPresenca`).then(
            res => {
                setIndPresenca(res.data);
            }
        ).catch(
            erro => {
                console.log(erro);
            }
        )

        api.get(`Enum/Listar?nome=StatusNFe`).then(
            res => {
                setStatus(res.data);
            }
        ).catch(
            erro => {
                console.log(erro);
            }
        )
    };

    function getDescricaoEnum(lista, key) {
        const item = lista.find(x => x.key === key);
        return item ? item.value : "Desconhecido";
    }

    function displayValue(value, fallback = "NÃO INFORMADO") {
        return value ? value : fallback;
    }

    return (
        <Modal destroyOnClose
            title="Detalhes da Nota Fiscal"
            open={exibirModalDetalhesNotaFiscal}
            getContainer={false}
            onCancel={onCloseModal}
            maskClosable={false}
            width="80%"
            footer={null}
        >
            <div>
                <Card title="Identificação do Destinatário"
                    size="small"
                    className="card-top"
                    styles={{ header: { backgroundColor: '#f1f1f1' } }}
                >
                    <Descriptions column={3} size="small" labelStyle={{ fontWeight: 'bold' }}>
                        <Descriptions.Item label="Nome">{displayValue(detalhesNF.ntf_nomedest)}</Descriptions.Item>
                        <Descriptions.Item label="CPF/CNPJ">{displayValue(detalhesNF.ntf_cnpjcpfdest)}</Descriptions.Item>
                        <Descriptions.Item label="IE">{displayValue(detalhesNF.ntf_iedest)}</Descriptions.Item>
                        <Descriptions.Item label="E-mail">{displayValue(detalhesNF.ntf_emaildest)}</Descriptions.Item>
                        <Descriptions.Item label="Telefone">{displayValue(detalhesNF.ntf_telefonedest)}</Descriptions.Item>
                    </Descriptions>
                    <Descriptions size="small" labelStyle={{ fontWeight: 'bold' }}>
                        <Descriptions.Item label="Endereço">
                            {detalhesNF.ntf_logradourodest || "NÃO INFORMADO"}
                            {detalhesNF.ntf_numeroenderecodest && `, Nº ${detalhesNF.ntf_numeroenderecodest}`}
                            {detalhesNF.ntf_bairrodest && `, ${detalhesNF.ntf_bairrodest}`}
                            {detalhesNF.ntf_municipiodest && ` - ${detalhesNF.ntf_municipiodest}`}
                            {detalhesNF.ntf_ufdest && `/${detalhesNF.ntf_ufdest}`}
                            {detalhesNF.ntf_cepdest && ` - CEP ${MaskFormat(detalhesNF.ntf_cepdest, '00000-000')}`}
                        </Descriptions.Item>
                    </Descriptions>
                </Card>
                <Card title="Dados da Nota Fiscal"
                    size="small"
                    className='card-bottom'
                    styles={{ header: { backgroundColor: '#f1f1f1', borderTopLeftRadius: 0, borderTopRightRadius: 0 } }}
                >
                    <Descriptions column={4} size="small" labelStyle={{ fontWeight: 'bold' }}>
                        <Descriptions.Item label="Número">{detalhesNF.ntf_numero}</Descriptions.Item>
                        <Descriptions.Item label="Data de Emissão">{moment(detalhesNF.ntf_dataemissao).format('DD/MM/YYYY HH:mm')}</Descriptions.Item>
                        <Descriptions.Item label="Série">{detalhesNF.ser_serie} - {detalhesNF.mdf_descricao}</Descriptions.Item>
                        <Descriptions.Item label="Chave">{displayValue(detalhesNF.ntf_chavenfe, 'NÃO DISPONÍVEL')}</Descriptions.Item>
                        <Descriptions.Item label="Status">{getDescricaoEnum(status, detalhesNF.ntf_status)}</Descriptions.Item>
                        <Descriptions.Item label="Data Ent/Sai.">{HasValue(detalhesNF.ntf_dhsaient) ? moment(detalhesNF.ntf_dhsaient).format('DD/MM/YYYY HH:mm') : ""}</Descriptions.Item>
                        <Descriptions.Item label="Operação">{detalhesNF.ope_descricao}</Descriptions.Item>
                        <Descriptions.Item label="Protocolo">{displayValue(detalhesNF.ntf_protocolonfe, 'NÃO DISPONÍVEL')}</Descriptions.Item>
                        <Descriptions.Item label="Ambiente">{arrAmbiente[detalhesNF.ntf_ambiente - 1]}</Descriptions.Item>
                        <Descriptions.Item label="Data Inclusão">{moment(detalhesNF.ntf_datainclusao).format('DD/MM/YYYY HH:mm')}</Descriptions.Item>
                        <Descriptions.Item label="Finalidade">{arrFinalidade[detalhesNF.ntf_finalidade - 1]}</Descriptions.Item>
                        <Descriptions.Item label="Indicador de Destino">
                            {detalhesNF.ntf_identificadordestino == 1 ? "Estadual" : detalhesNF.ntf_identificadordestino == 2 ? "Interestadual" : "Exterior"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Ind. Presença">
                            {getDescricaoEnum(indPresenca, detalhesNF.ntf_indicadorpresenca)}
                        </Descriptions.Item>
                        <Descriptions.Item label="Frete">
                            {getDescricaoEnum(modalidadesFrete, detalhesNF.ntf_modalidadefrete)}
                        </Descriptions.Item>
                    </Descriptions>
                    <Descriptions column={1} size="small" labelStyle={{ fontWeight: 'bold' }}>
                        <Descriptions.Item label="Informações Complementares">
                            {displayValue(detalhesNF.ntf_infcomplementar, '')}
                        </Descriptions.Item>
                    </Descriptions>
                </Card>

                <div className="m-t-16">
                    <Tabs type="card" centered activeKey={abaSelecionada} onChange={(tab) => setAbaSelecionada(tab)}>
                        <Tabs.TabPane tab="Itens" key="1">
                            <Itens itensNota={detalhesNota.itensNf} />
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="Forma de Pagamento" key="2">
                            <FormaPagamento formaPagamento={detalhesNota.formaPgto} />
                        </Tabs.TabPane>
                    </Tabs>
                </div>
            </div>
        </Modal>
    );
}